import { FC, SVGProps } from 'react';
import * as React from 'react';

const ReportsIconSidebar: FC<SVGProps<SVGSVGElement>> = (props): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 22}
    height={props.height || 22}
    viewBox="0 0 24 28"
    fill="none"
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      d="M1.84473 6.39319V22.8955C1.84473 25.9508 2.59768 26.7037 5.65299 26.7037H18.3472C21.4025 26.7037 22.1554 25.9508 22.1554 22.8955V10.2014C22.1554 7.14613 21.4025 6.39319 18.3472 6.39319H1.84473ZM1.84473 6.39319V5.12378"
      stroke="#9395A1"
      strokeWidth="2"
    />
    <path
      opacity="0.2"
      d="M19.6166 6.39326H3.20436C2.45346 6.39326 1.84473 5.78454 1.84473 5.03364C1.84473 4.35702 2.34226 3.78337 3.01208 3.68768L16.7187 1.72961C19.2003 1.51111 19.6166 2.69791 19.6166 4.24291V6.39326Z"
      fill="#9395A1"
    />
    <path
      d="M19.6166 6.39326V7.39326H20.6166V6.39326H19.6166ZM16.7187 1.72961L16.631 0.73346L16.6041 0.735832L16.5773 0.739657L16.7187 1.72961ZM3.01208 3.68768L2.87066 2.69773L2.87066 2.69773L3.01208 3.68768ZM3.20436 7.39326H19.6166V5.39326H3.20436V7.39326ZM20.6166 6.39326V4.24291H18.6166V6.39326H20.6166ZM16.5773 0.739657L2.87066 2.69773L3.1535 4.67763L16.8601 2.71956L16.5773 0.739657ZM2.87066 2.69773C1.70819 2.8638 0.844727 3.85936 0.844727 5.03364H2.84473C2.84473 4.85468 2.97632 4.70294 3.1535 4.67763L2.87066 2.69773ZM20.6166 4.24291C20.6166 3.44134 20.5243 2.41827 19.8431 1.65775C19.1193 0.849675 17.9997 0.612952 16.631 0.73346L16.8064 2.72575C17.9193 2.62777 18.2486 2.8752 18.3534 2.99215C18.5007 3.15665 18.6166 3.49947 18.6166 4.24291H20.6166ZM3.20436 5.39326C3.00573 5.39326 2.84473 5.23224 2.84473 5.03364H0.844727C0.844727 6.33683 1.90118 7.39326 3.20436 7.39326V5.39326Z"
      fill="#9395A1"
    />
    <path
      d="M6.92236 14.0098H17.0777"
      stroke="#9395A1"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6.92236 19.4045H13.9042"
      stroke="#9395A1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ReportsIconSidebar;
